
<p-toast></p-toast>
<div class="pane">

	<section class="contact-info">

		<div class="card mt-6 p-4 rounded-xl border border-gray-200 bg-white shadow-md transition transform hover:shadow-lg hover:-translate-y-0.5">
			<h2>Store/Account</h2>
			** In the event this claim is submitted 10 days post product arrival, the claim may be denied.
			<br>		<br>		<br>
			<div class="field-holder">
				<div class="field">
					<label>Account Number</label>
					<input pInputText [(ngModel)]="shippingError.accountNumber" disabled>
				</div>
				<div class="field">
					<label>Store Name</label>
					<input pInputText [(ngModel)]="shippingError.storeName" disabled>
				</div>
			</div>

			<h2>Contact Info</h2>

			<div class="field-holder">

				<div class="field">
					<label><i class="pi pi-user mr-1"></i> First Name</label>
					<input type="text" pInputText [(ngModel)]="shippingError.firstName" [ngClass]="{error: submitted && !shippingError.firstName}">
				</div>

				<div class="field">
					<label><i class="pi pi-user mr-1"></i> Last Name</label>
					<input type="text" pInputText [(ngModel)]="shippingError.lastName" [ngClass]="{error: submitted && !shippingError.lastName}">
				</div>

				<div class="field">
					<label><i class="pi pi-envelope mr-1"></i> Email</label>
					<input type="text" pInputText [(ngModel)]="shippingError.email" [ngClass]="{error: submitted && !shippingError.email}">
				</div>

			</div>
		</div>



		<div class="card mt-6 p-4 rounded-xl border border-gray-200 bg-white shadow-md transition transform hover:shadow-lg hover:-translate-y-0.5">
			<!-- Ask error type first -->
			<div class="card error-type-selector mb-4 p-4 rounded-xl shadow-sm">
				<label class="block mb-3 text-lg font-semibold text-gray-800">
					<i class="pi pi-truck mr-2 text-primary"></i> What kind of shipping error is this?
				</label>

				<div class="flex flex-wrap gap-4">
					<div class="flex items-center gap-2">
						<p-radioButton name="errorType"
													 inputId="overage"
													 value="OverageShortage"
													 [(ngModel)]="selectedErrorType">
						</p-radioButton>
						<label for="overage" class="cursor-pointer">
							<i class="pi pi-box mr-1 text-blue-500"></i> Overage / Shortage
						</label>
					</div>

					<div class="flex items-center gap-2">
						<p-radioButton name="errorType"
													 inputId="damaged"
													 value="Damaged"
													 [(ngModel)]="selectedErrorType">
						</p-radioButton>
						<label for="damaged" class="cursor-pointer">
							<i class="pi pi-times-circle mr-1 text-red-500"></i> Damaged
						</label>
					</div>

					<div class="flex items-center gap-2">
						<p-radioButton name="errorType"
													 inputId="wrong"
													 value="Wrong"
													 [(ngModel)]="selectedErrorType">
						</p-radioButton>
						<label for="wrong" class="cursor-pointer">
							<i class="pi pi-question-circle mr-1 text-yellow-500"></i> Wrong Item
						</label>
					</div>
				</div>
			</div>
		</div>




		<div class="card mt-6 p-4 rounded-xl border border-gray-200 bg-white shadow-md transition transform hover:shadow-lg hover:-translate-y-0.5">

			<div *ngIf="!selectedErrorType" class="p-4 mb-4 text-sm text-yellow-800 bg-yellow-100 border-l-4 border-yellow-500 rounded">
				<i class="pi pi-info-circle mr-2"></i>
				Please select the type of shipping error to continue.
			</div>

			<div *ngIf="selectedErrorType">
				<div class="card mb-4 rounded-xl shadow-sm overflow-hidden border border-gray-200">
					<div class="card-header flex justify-between items-center p-4 bg-gray-50 cursor-pointer"
							 (click)="toggleProductList()">
						<h3 class="text-lg font-semibold text-gray-800 flex items-center gap-2">
							<i class="pi pi-list text-primary"></i>
							Search Shipping Order #
						</h3>
						<div class="flex items-center gap-2 text-sm text-blue-600">
							{{ showProductList ? 'Hide' : 'Show' }}
							<i class="pi" [ngClass]="showProductList ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
						</div>
					</div>

					<div class="card-body p-4" *ngIf="showProductList">
						<p class="mb-4 text-sm text-gray-600">
							Please select the shipping order # associated with the order. You may search by: PO, Invoice#, Order#, Ship#, or date (MM-DD-YYYY).<br><br>
							Products must all be on the same invoice or packing slip. If they are on separate ones, please submit a separate shipping error.
						</p>

						<app-po-search (onSelect)="setShipNumber($event)"
													 (productSelected)="addFromPO($event)">
						</app-po-search>

						<ng-container *ngIf="ShipNumber && filteredSortedProducts?.length > 0">

							<input type="text" pInputText placeholder="Search products..." class="mb-3 w-full" />

							<p-dropdown [options]="sortOptions"
													[(ngModel)]="selectedSort"
													placeholder="Sort by Code"
													class="mb-4 w-60">
							</p-dropdown>

							<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
								<!-- Product cards render here -->
							</div>
						</ng-container>
					</div>
					<label class="error block px-4 pb-4" *ngIf="submitted && !ShipNumber">
						Please be sure to select a shipping #.
					</label>
				</div>
			</div>
		</div>



	</section>





	<!-- Only show tabs and sections if type is selected -->
	<div class="card mt-6 p-4 rounded-xl border border-gray-200 bg-white shadow-md transition transform hover:shadow-lg hover:-translate-y-0.5">

		<div *ngIf="!selectedErrorType" class="p-4 mb-4 text-sm text-yellow-800 bg-yellow-100 border-l-4 border-yellow-500 rounded">
			<i class="pi pi-info-circle mr-2"></i>
			Please select the type of shipping error to continue.
		</div>

		<div *ngIf="selectedErrorType">
			<div class="tab-content">
				<section *ngIf="openTab === 'OverageShortage'">
					<h3>Overage/Shortage</h3>
					<p>Which product(s) is/are affected?</p>
					<div class="affected-product header">
						<div class="product-code">Product Code</div>
						<div class="description">Description</div>
						<div class="quantity">Quantity</div>
						<div class="type">Type</div>
						<div class="serial">Serial</div>
						<div class="delete">&nbsp;</div>
					</div>
					<div class="affected-product" *ngFor="let ap of affectedProductsOverage">

						<div class="product-code">
							<app-product-code-search [Exclude]="'ExcludeDiscontinued'"
																			 (onSelect)="setProduct($event, ap)"
																			 [productCodeInput]="ap.productCode"></app-product-code-search>
						</div>

						<div class="description">{{ap.description}}</div>
						<div class="quantity"><input pInputText [(ngModel)]="ap.quantity" type="number" min="0" [ngClass]="{error: submitted && !ap.quantity}"></div>
						<div class="type"><p-dropdown [(ngModel)]="ap.errorType" (onChange)="AddSerial($event)" [options]="overageShortageOptions" [autoDisplayFirst]="false" [ngClass]="{error: submitted && !ap.errorType}"></p-dropdown></div>
						<div class="serial" *ngIf="ap.errorType == 'Overage'"> <input pInputText [(ngModel)]="ap.serial"></div>


						<div class="delete">
							<div class="button" (click)="deleteProduct(ap.index)"></div>
						</div>

					</div>

					<div class="actions">
						<div class="button white-button" (click)="addNew('overage')">Add Product</div>
					</div>

					<!--<p>Show our UPS account info and ask that the itme(s) be forwarded with our account.  If they do not have UPS please use another provider and email Brianna the total and we will issue credit for the forwarding.  We do not issue call tags.</p>-->

					<div class="field" *ngIf="hasOverages">
						<label [ngClass]="{error: submitted && shippingError.keepOrRma == undefined && hasOverages}">For the overages, or items you did not order, do you want to...</label><br /><br />
						<div class="options">
							<p-radioButton name="keepOrRma" value="keep" [(ngModel)]="shippingError.keepOrRma" label="Keep the products.  Please charge me for them."></p-radioButton>
							<p-radioButton name="keepOrRma" value="rma" [(ngModel)]="shippingError.keepOrRma" label="Request an RMA so I can return them"></p-radioButton>
						</div>
					</div>
				</section>


				<section *ngIf="openTab === 'Damaged'">
					<!-- Damaged UI goes here -->
					<h3>Damaged Items Received</h3>
					<p>Please provide photos of the damage</p>
					<p-fileUpload (onSelect)="onSelect($event, 'damage')" multiple="multiple" [showUploadButton]="false" [showCancelButton]="false" #damagePhotoUploads></p-fileUpload>

					<p>Which product(s) is/are damaged?</p>
					<div class="affected-product header">
						<div class="product-code">Product Code</div>
						<div class="description">Description</div>
						<div class="quantity">Quantity</div>
						<div class="type">Type</div>
						<div class="delete">&nbsp;</div>
					</div>

					<div class="affected-product" *ngFor="let ap of affectedProductsDamaged">

						<div class="product-code">
							<app-product-code-search [Exclude]="'ExcludeDiscontinued'"
																			 [productCodeInput]="ap.productCode"
																			 (onSelect)="setProduct($event, ap)"></app-product-code-search>
						</div>

						<div class="description">{{ap.description}}</div>

						<div class="quantity"><input pInputText [(ngModel)]="ap.quantity" min="0" type="number"></div>

						<div class="type">Damaged</div>

						<div class="delete"><div class="button" (click)="deleteProduct(ap.index)"></div></div>

					</div>

					<div class="actions">
						<div class="button white-button" (click)="addNew('damage')">Add Another Product</div>
					</div>

					<label [ngClass]="{error: submitted && shippingError.upsNotified == undefined && hasDamaged}">Was UPS notified of the damage at the time of delivery?</label>

					<div class="options">
						<p-radioButton name="upsNotified" [value]="true" [(ngModel)]="shippingError.upsNotified" label="Yes"></p-radioButton>
						<p-radioButton name="upsNotified" [value]="false" [(ngModel)]="shippingError.upsNotified" label="No"></p-radioButton>
					</div>

					<!--<label [ngClass]="{error: submitted && shippingError.keepDamagedProducts == undefined && hasDamaged}">Would you like to keep the products for display use, at 50% off the price?</label>
					<div class="options">
						<p-radioButton name="keepDamagedProducts" [value]="true" [(ngModel)]="shippingError.keepDamagedProducts" label="Yes"></p-radioButton>
						<p-radioButton name="keepDamagedProducts" [value]="false" [(ngModel)]="shippingError.keepDamagedProducts" label="No"></p-radioButton>
					</div>-->

				</section>

				<section *ngIf="openTab === 'Wrong'">
					<!-- Wrong Order UI goes here -->
					<h3>Received box/order that is not mine</h3>
					<label>Will forward to correct store?</label>
					<div class="options">

						<p-radioButton name="willForward" [value]="true" [(ngModel)]="shippingError.willForward" label="Yes"></p-radioButton>
						<p-radioButton name="willForward" [value]="false" [(ngModel)]="shippingError.willForward" label="No, we would like a call from someone in the office to discuss"></p-radioButton>

						<sectionForward *ngIf="shippingError.willForward">

							<p>
								You have selected that you would like to forward this package to the correct store. If possible, please use our UPS account to forward this package:
								<br /><br />
								PRO UPS #     262-730
								<br /><br />
								Address used for UPS Billing:<br />
								Pro Warehouse<br />
								2950 Turnpike Dr Sec 4-9<br />
								Hatboro, PA 19040<br />
								<br /><br />
								If you do not have UPS as a shipping service, you may use your own shipping method and then submit the charges to your Pro Sales Contact to be reimbursed the forwarding cost. Thank you!'
							</p>

						</sectionForward>
					</div>
				</section>
			</div>

		</div>

	</div>


	<div *ngIf="validationErrors.length" class="bg-red-100 border border-red-400 text-red-800 rounded p-4 mb-4">
		<ul class="list-disc pl-5 space-y-1">
			<li *ngFor="let error of validationErrors">{{ error }}</li>
		</ul>
	</div>




	<!-- Summary Card -->
	<div class="card mt-6 p-4 rounded-xl border border-gray-200 bg-white shadow-md" *ngIf="affectedProducts.length > 0">
		<h3 class="text-lg font-semibold text-gray-800 mb-4">
			<i class="pi pi-clipboard-check text-green-600 mr-2"></i>
			Review Shipping Error Summary
		</h3>

		<div class="summary-grid">
			<div class="summary-card" *ngFor="let product of affectedProducts">
				<div class="sku">{{ product.productCode }}</div>
				<div class="desc">{{ product.description }}</div>
				<div class="details">
					Type: <span>{{ product.errorType }}</span> |
					Qty: <span>{{ product.quantity || 'N/A' }}</span>
				</div>

			</div>
		</div>
	</div>





	<div class="actions">
		<div class="button" (click)="submit()">Submit</div>
	</div>





</div>
